import building from "@/assets/brand/building.webp";
import chefLogo from "@/assets/brand/chef-logo.png";

export const BRAND = { building, chefLogo };

export const FOOD = {
  fishCurry:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/f87b99aa5dbd19513063b0873198e2218109091332bf6d1ca3ccae12271ab33f.jpeg",
  tandoorLamb:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/def1674757edd20aff9d5f3b65978f00983c58690f1b0847f3377be5bfadf3ad.jpeg",
  biriyani:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/7c018b776b533b9e2a3ccd2fdd37e8bbd5e35ca4274db2002c2415c2010fee07.jpeg",
  scallops:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/8d28b960a97d6726efbffe84fabb28c52938a0657653cd5f9fc87c252db11805.jpeg",
  tandoorFire:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/65c46d3e83ec44a209b558bc8a2c07f5f139014533b06d3b2b929fe7b4e52cf7.jpeg",
  spices:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/d7808c5d4cf972c6742250011929f90645aa60df6f60e07d1c49ff41fc173708.jpeg",
  breads:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/c59d90af2bf544987c0e9ca50e100ac69e4b7790efc19f48c18f601ce2bcfb2e.jpeg",
  dessert:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/ecd7bec847fe16dd9f2d6675f75d8048aa99b6c9b6c66cc637dfe0c521df8ef8.jpeg",
};

export const SCENE = {
  interiorWarm:
    "https://images.unsplash.com/photo-1602232037779-30b01ac3c457?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  interiorTables:
    "https://images.unsplash.com/photo-1578474846511-04ba529f0b88?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  interiorLights:
    "https://images.unsplash.com/photo-1770736929333-4fb8cd5a1657?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  chefPlating:
    "https://images.unsplash.com/photo-1621494268492-d01b98eba7e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  tableSetting:
    "https://images.pexels.com/photos/36747296/pexels-photo-36747296.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
  chefFire:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/a394e55eaeb3933ea13fea481eebc8f90abd3dfb2488fd187c8e110773e42bbb.jpeg",
  heritageInterior:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/b435220d9c723b868a0e5071467f40bb625a8f29f411983258a0b53b0e5ba667.jpeg",
  seafoodPlatter:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/136cbb5d6f6eead2cae06053d00f965b6c62d247e4c0c6ca3406aa94827a300b.jpeg",
  darkInterior:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/ef743ab0c5461aa574f7540dee0f9d2a90507677001ab044548acfc589e9ecd6.jpeg",
  coconutCurryleaf:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/90256782c3758503e86654ea230f56c7be3406d8bba81739920c2f34832d58df.jpeg",
  curryPour:
    "https://static.prod-images.emergentagent.com/jobs/c0750e1f-a22c-40f3-b65b-17b6ba38b5bd/images/9b64242d2c8567525ef87447328de9bd730300b0c546f84506e0fd069bdabfb1.jpeg",
};
